import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const FontStylesIcon = ({
  className = '',
  color = bdlGray,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <rect
      fill={color}
      height="1.86667"
      rx="0.933333"
      width="11.2"
      x="3.8"
      y="7.56705"
    />
    <circle cx="1.93333" cy="8.50038" fill={color} r="0.933333" />
    <rect
      fill={color}
      height="1.86667"
      rx="0.933333"
      width="11.2"
      x="3.8"
      y="2.90039"
    />
    <circle cx="1.93333" cy="3.83372" fill={color} r="0.933333" />
    <rect
      fill={color}
      height="1.86667"
      rx="0.933333"
      width="11.2"
      x="3.8"
      y="12.2337"
    />
    <circle cx="1.93333" cy="13.1671" fill={color} r="0.933333" />
  </AccessibleSVG>
);

export default FontStylesIcon;
